import $ from "jquery"
import './../scss/style.scss';

import { affixFafix } from './shared/affix-fafix'
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { initSounds } from './amzn/sounds'
import { startAnimation } from './loading'
import { initImgFull } from "./amzn/imgfull";

//  import Bootstrap 
require('bootstrap');

$(() => {
  // do stuff on ready
  affixFafix()
  initCommon()
  initCookies()
  initSounds()
  startAnimation()
  initImgFull()
});

$(window).on( "load", ()=> {
  // do stuff on load

});